/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_ImportingInputs */

const vi_import_importing = /** @type {(inputs: Import_ImportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang import...`)
};

/**

* @param {Import_ImportingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_importing = /** @type {((inputs?: Import_ImportingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_ImportingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_importing(inputs)
});